import {GET_PARAM_NAME} from '@views/dashboard/manager/Body';

export function getManagerDashboardProductsListSearchParams(additionalSearchParams: Record<string, string> = {}): Record<string, string> {
    return {
        [GET_PARAM_NAME]: 'Dashboards:Manager.tabs.order-products',
        ...additionalSearchParams,
    };
}

export function getManagerDashboardProductsListSearchParamsAsString(additionalSearchParams: Record<string, string> = {}): string {
    return new URLSearchParams(
        getManagerDashboardProductsListSearchParams(additionalSearchParams)
    ).toString();
}
